import * as yup from 'yup';

yup.addMethod(yup.string, 'fillWidth', function() {
  return this.test('fillWidth', '全角で入力して下さい。', function(value) {
    const { createError, path } = this
    if(value.match(/^[^\x01-\x7E\uFF61-\uFF9F]+$/)) return true
    return createError({path,message: '${path}は全角で入力してください。'})
  });
});

yup.addMethod(yup.string, 'halfWidth', function() {
  return this.test('halfWidth', '半角で入力して下さい。', function(value) {
    const { createError, path } = this
    if(!value.match(/^[^\x01-\x7E\uFF61-\uFF9F]+$/)) return true
    return createError({path,message: '${path}は半角で入力してください。'})
  });
});

yup.addMethod(yup.string, 'number', function() {
  return this.test('number', '数字で入力してください。', function(value) {
    const { createError, path } = this
    if(value.match(/^[0-9]+$/)) return true
    return createError({path,message: '${path}は数字で入力してください。'})
  });
});

yup.addMethod(yup.string, 'katakana', function() {
  return this.test('katakana', 'カタカナで入力して下さい。', function(value) {
    const { createError, path } = this
    if(value.match(/^[ァ-ヶｦ-ﾟ]+$/)) return true
    return createError({path,message: '${path}はカタカナで入力してください。'})
  });
});

yup.addMethod(yup.string, 'phoneNumber', function() {
  return this.test('phoneNumber', '電話番号（ハイフンあり）の形式ではありません。', function(value) {
    const { createError, path } = this
    if(value.match(/^0[0-9-]{1,12}$/)) return true
    return createError({path,message: '${path}（ハイフンあり）の形式が正しくありません。'})
  });
});

yup.addMethod(yup.string, 'postalCode', function() {
  return this.test('postalCode', '郵便番号は7桁の数字で入力してください。', function(value) {
    const { createError, path } = this
    if(value.match(/^\d{7}$/)) return true
    return createError({path,message: '${path}は7桁の数字で入力してください。'})
  });
});

yup.addMethod(yup.string, 'password', function() {
  return this.test('password', 'パスワードは半角英数字と一部記号のみです。', function(value) {
    const { createError, path } = this
    if(value.match(/^[!-~]*$/)) return true
    return createError({path,message: '${path}は半角英数字と一部記号のみです。'})
  });
});

yup.addMethod(yup.string, 'birthYear', function() {
  return this.test('number', '正しい年を入力してください', function(value) {
    const { createError, path } = this
    if(value >= 1900 && value <= new Date().getFullYear()) return true
    return createError({path,message: '${path}は正しい年を入力してください'})
  });
});

yup.addMethod(yup.string, 'birthMonth', function() {
  return this.test('number', '正しい月で入力してください', function(value) {
    const { createError, path } = this
    if(value >= 1 && value <= 12) return true
    return createError({path,message: '${path}は正しい月で入力してください'})
  });
});

yup.addMethod(yup.string, 'birthDate', function() {
  return this.test('number', '正しい日で入力してください', function(value) {
    const { createError, path } = this
    if(value >= 1 && value <= 31) return true
    return createError({path,message: '${path}は正しい日で入力してください'})
  });
});

yup.setLocale({
  mixed: {
    defalut: '不正な値です。',
    notType: "不正な値です。",
    required: ({ label }) => `${label}は必須の項目です。`,
  },
  string: {
    email: 'メールアドレスの形式ではありません。',
    min:({min, label})=> `${label}は${min}文字以上で入力してください。`,
    max:({max, label})=> `${label}は${max}文字以下で入力してください。`,
  },
  number:{
    min:({min, label})=> `${label}は${min}文字以上で入力してください。`,
    max:({max, label})=> `${label}は${max}文字以下で入力してください。`,
  }
});